import * as React from 'react';
/** @deprecated Work with your designer to replace with one of the current illustrations (https://lens.loom.dev/illustrations/illustration-set). */
function IllustrationAccountsBilling(props) {
  return (
    <svg
      viewBox="0 0 102 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M96.072 5.826H5.928v90.145h90.144V5.826z"
        stroke="currentColor"
        strokeWidth={10}
        strokeMiterlimit={10}
      />
      <path
        d="M69.38 59.21c14.74 0 26.691-11.95 26.691-26.692S84.121 5.826 69.38 5.826c-14.741 0-26.692 11.95-26.692 26.692S54.638 59.21 69.38 59.21zM1 95.973h100M1 77.28h100M1 59.213h100M5.928 1v58.213M24.605 1v58.213M42.674 1v58.213"
        stroke="currentColor"
        strokeWidth={10}
        strokeMiterlimit={10}
      />
    </svg>
  );
}

export default IllustrationAccountsBilling;
